<template>
  <div class="legal-page">
    <div class="container">
      <h1>Privacy Policy</h1>
      <p class="last-updated">Last updated: {{ new Date().toLocaleDateString() }}</p>

      <section>
        <h2>1. Introduction</h2>
        <p>Welcome to L2L.fun ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website https://go.l2l.fun (the "Site").</p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>We may collect information about you in a variety of ways. The information we may collect on the Site includes:</p>
        <ul>
          <li><strong>Personal Data:</strong> We do not collect personally identifiable information (such as your name, email address, or phone number) unless you voluntarily provide it to us (e.g., by contacting us).</li>
          <li><strong>Derivative Data:</strong> Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site.</li>
        </ul>
      </section>

      <section>
        <h2>3. Use of Cookies and Web Beacons</h2>
        <p>We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Site to help customize the Site and improve your experience. When you access the Site, your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the Site.</p>
      </section>

      <section>
        <h2>4. Google AdSense and DoubleClick Cookie</h2>
        <p>Google, as a third-party vendor, uses cookies to serve ads on our Site. Google's use of the DART cookie enables it to serve ads to our users based on their visit to our Site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google ad and content network privacy policy at the following URL – <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener">https://policies.google.com/technologies/ads</a>.</p>
        <p>We use Google AdSense Advertising on our website. Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users.</p>
      </section>

      <section>
        <h2>5. Third-Party Disclosure</h2>
        <p>We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.</p>
      </section>

      <section>
        <h2>6. Contact Us</h2>
        <p>If you have questions or comments about this Privacy Policy, please contact us at:</p>
        <p>Email: xendor@xendor.pub</p>
      </section>
      
      <div class="back-link">
        <router-link to="/">← Back to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.legal-page {
  padding: 40px 20px;
  color: #fff;
  min-height: 80vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  color: #fff;
}

.last-updated {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 40px;
  font-style: italic;
}

section {
  margin-bottom: 30px;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #e0eaff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}

p, li {
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 10px;
}

ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

a {
  color: #667eea;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.back-link {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.back-link a {
  display: inline-block;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: white;
  transition: background 0.3s;
}

.back-link a:hover {
  background: rgba(255, 255, 255, 0.2);
  text-decoration: none;
}
</style>
